/**
 数据格式化 过滤器
 */
const vFilter = {
  //金额保留小数点两位数的格式
  moneyFormat:function (value) {
    if (!value) return '0';
    let intPart = Math.floor(value); //获取整数部分
    //var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+)/g, '1,'); //将整数部分逢三一断
    let floatPart = ".00"; //预定义小数部分
    let value2Array = String(value).split(".");
    //=2表示数据有小数位
    if (value2Array.length == 2) {
      floatPart = value2Array[1].toString(); //拿到小数部分
      if (floatPart.length == 1) { //补0,实际上用不着
        return intPart + "." + floatPart + '0';
      } else {
        return intPart + "." + floatPart;
      }
    } else {
      return intPart + floatPart;
    }
  },
  //保留小数后两位
  filterMoney: function(money, len = 2, split = ',') {
    len = Math.abs((+len) % 20);
    money = parseFloat((money + "").replace(/[^\d.-]/g, "")).toFixed(len) + "";
    return money.replace(/\d+/, function (money) {
      let lit = money.length % 3 == 0;
      let index = lit ? money.length - 3 : -1;
      return money.split('').reverse().join('').replace(/\d{3}/g, function (k, l) {
        return k + ((l == index && lit) ? "" : split);
      }).split('').reverse().join('')
    });
  },
  //格式化金额 例如 100,444,333.00
  moneyFormat3:function(value) {
    if (!value) return '0';
    let intPart = Math.floor(value); //获取整数部分
    var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断
    let floatPart = ".00"; //预定义小数部分
    let value2Array = String(value).split(".");
    //=2表示数据有小数位
    if (value2Array.length == 2) {
    floatPart = value2Array[1].toString(); //拿到小数部分
    if (floatPart.length == 1) { //补0,实际上用不着
        return intPartFormat + "." + floatPart + '0';
    } else {
        return intPartFormat + "." + floatPart.substring(0, 2);
    }
    } else {
    return intPartFormat + floatPart;
    }
  },
  //年-月-日格式转换
  dateFormat:function(date){
    if(date && date !== ''){
      date = new Date(date);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      if(month < 10){
        month = '0' + month;
      }
      let day = date.getDate();
      if(day < 10){
        day = '0' + day;
      }
      return year+'-'+month+'-'+day;
    }
  },
  phoneNumFormat:function (value) {
    if(value && value !== "")
      return value.substr(0,3) + '****' + value.substr(-4,4);
  },
  cardNumFormat:function (value) {
    if(value && value !== "")
      return value.substr(0,4) + '**********' + value.substr(-4,4);
  },
  //证件类型
  transformCardType:function (type) {
    let cardType = '';
    switch (type) {
      case '0':
        cardType = "身份证";
        break;
      default:
        cardType = "";
        break;
    }
    return cardType;
  },
  //性别类型
  transformSex:function (value) {
    let sex = '';
    switch (value) {
      case 1:
        sex = "男";
        break;
      case 2:
        sex = "女";
        break;
      default:
        sex = "";
        break;
    }
    return sex;
  },
  //客户类型
   customerType:function (value) {
    let type = '';
    switch (value) {
      case '1800191':
        type = "新增客户";
        break;
      case '1800192':
        type = "结清再贷";
        break;
      case '1800193':
        type = "债务重组";
        break;
      case '1800194':
        type = "追加";
        break;
      default:
        type = "新增客户";
        break;
    }
    return type;
  },
/**
  根据身份证号码判断性别
  15位身份证号码：第7、8位为出生年份(两位数)，第9、10位为出生月份，第11、12位代表出生日
  18位身份证号码：第7、8、9、10位为出生年份(四位数)，第11、第12位为出生月份，
  第13、14位代表出生日期，第17位代表性别，奇数为男，偶数为女。
  */
  //根据身份证号获取年龄
  getAge(identityCard) {
    let len = (identityCard + "").length;
    let strBirthday = "";
    if (len == 18) {
      //处理18位的身份证号码从号码中得到生日和性别代码
      strBirthday =
        identityCard.substr(6, 4) +
        "/" +
        identityCard.substr(10, 2) +
        "/" +
        identityCard.substr(12, 2);
    }
    if (len == 15) {
      let birthdayValue = "";
      birthdayValue = identityCard.charAt(6) + identityCard.charAt(7);
      if (parseInt(birthdayValue) < 10) {
        strBirthday =
          "20" +
          identityCard.substr(6, 2) +
          "/" +
          identityCard.substr(8, 2) +
          "/" +
          identityCard.substr(10, 2);
      } else {
        strBirthday =
          "19" +
          identityCard.substr(6, 2) +
          "/" +
          identityCard.substr(8, 2) +
          "/" +
          identityCard.substr(10, 2);
      }
    }
    //时间字符串里，必须是“/”
    let birthDate = new Date(strBirthday);
    let nowDateTime = new Date();
    let age = nowDateTime.getFullYear() - birthDate.getFullYear();
    //再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
    if (
      nowDateTime.getMonth() < birthDate.getMonth() ||
      (nowDateTime.getMonth() == birthDate.getMonth() &&
        nowDateTime.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  },
};


export default vFilter



// WEBPACK FOOTER //
// ./src/util/filters.js